var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "95qgh09uba",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2q9r3svr8b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#95qgh09uba"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.429 6.857h6V16H2.857a1.715 1.715 0 0 1-1.714-1.714V6.857c.095.009.19.009.286 0zm13.142 0c.095.009.191.009.286 0v7.429A1.715 1.715 0 0 1 13.143 16H8.57V6.857h6zM4 2.286a1.143 1.143 0 0 1 1.143-1.143 2.285 2.285 0 0 1 2.286 2.286H5.143A1.143 1.143 0 0 1 4 2.286zm6.857-1.143a1.143 1.143 0 0 1 0 2.286H8.571a2.285 2.285 0 0 1 2.286-2.286zm3.714 2.286h-1.748c.208-.346.318-.74.32-1.143A2.285 2.285 0 0 0 10.857 0C9.707 0 8.634.578 8 1.537A3.429 3.429 0 0 0 5.143 0a2.285 2.285 0 0 0-2.286 2.286c.002.403.112.797.32 1.143H1.43a1.429 1.429 0 0 0 0 2.857H14.57a1.429 1.429 0 0 0 0-2.857z",
    fill: "#0C131A",
    mask: "url(#2q9r3svr8b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.0af644284d45d09c0c949b5fd040e5c5.svg";
export { ForwardRef as ReactComponent };